function CheckOrderModalCtrl(checkOrderService, checkOrderData) {
  const ctrl = this;
  ctrl.isLoaded = false;
  ctrl.historyCountVisible = 5;
  checkOrderService.getStatus(checkOrderData.orderNumber).then(status => {
    ctrl.data = status;
  }).finally(() => {
    ctrl.isLoaded = true;
  });
}
CheckOrderModalCtrl.$inject = ["checkOrderService", "checkOrderData"];
export default CheckOrderModalCtrl;